
<template>
    <div id="PrayerRequest" style="display: none;">
        <!-- <a class="waves-effect waves-light btn-large modal-trigger" href="mailto:houseoffirechristianchurch@gmail.com?subject=Please pray for...&body=Please provide you name, phone, and prayer request(s).">Share</a> -->
        <a class="waves-effect waves-light btn-large modal-trigger" v-on:click="open()">Share</a>
        <modal name="PrayerRequest" transition="pop-out" :width="modalWidth" height="auto" @before-open="beforeOpen" @before-close="beforeClose" :resizable="true" :adaptive="true">
            <div class="row">
                <ValidationObserver v-slot="{ handleSubmit, reset }">
                    <form @submit.prevent="handleSubmit(onSubmit)" @reset.prevent="reset">
                        <div class="row">
                            <div class="title">Prayer Request Form</div>
                            <div class="close"><a @click="$modal.hide('PrayerRequest')"><i class="material-icons">close</i></a></div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12 m6">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <label for="FirstName" class="active">First Name *</label>
                                    <input id="FirstName" type="text" class="validate" v-model="form.FirstName" :disabled="isDisabled ? 'disabled' : false" maxlength="75" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="input-field col s12 m6">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <label for="LastName" class="active">Last Name *</label>
                                    <input id="LastName" type="text" class="validate" v-model="form.LastName" placeholder=" " :disabled="isDisabled ? 'disabled' : false" maxlength="75" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12 m6">
                                <ValidationProvider rules="email" v-slot="{ errors }">
                                    <label for="Email" class="active">Email</label>
                                    <input id="Email" type="text" class="validate" v-model="form.Email" :disabled="isDisabled ? 'disabled' : false" maxlength="125" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="input-field col s12 m6">
                                <ValidationProvider rules="phone" v-slot="{ errors }">
                                    <label for="Phone" class="active">Phone</label>
                                    <input id="Phone" type="text" class="validate" v-model="form.Phone" :disabled="isDisabled ? 'disabled' : false" maxlength="10" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"/>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <label for="Request" class="active">Request *</label>
                                    <textarea id="Request" class="materialize-textarea" v-model="form.Request" :disabled="isDisabled ? 'disabled' : false" maxlength="500" oninput="javascript: if (this.value.length > this.maxlength) this.value=this.value.slice(0,this.maxlength);"></textarea>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12 center">
                                <div v-if="success == true" class="success">Your prayer request has been received.</div>
                                <button v-if="success == false" class="waves-effect waves-light btn" type="submit" :disabled="isDisabled ? 'disabled' : false">Submit</button>
                                <div class="reset-div"><button class="transparent" v-on:click="resetForm()" type="reset">Reset Form</button></div>
                            </div>
                        </div>       
                    </form>
                </ValidationObserver>
            </div>       
        </modal>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import M from 'materialize-css';
import MessagesService from '../services/Messages.js';

    extend('phone', value => {
        var patt = new RegExp(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im);
        if (value.length > 0) {
            if (!patt.test(value)) {
                return 'Enter a valid phone number.';
            }
            else {
                return true;
            }
        }
    });
    // No message specified.
    extend('email', {
        ...email,
        message: 'Enter a valid email.'
    });

    // Override the default message.
    extend('required', {
        ...required,
        message: 'Required'
    });


export default {
    name: "PrayerRequest",
    components: { ValidationProvider, ValidationObserver },
    data: function() {
        return {
            modalWidth: 700,
            form: {
                FirstName: "",
                LastName: "",
                Email: "",
                Phone: "",
                Request: ""
            },
            isDisabled: false,
            success: false
        }
    },
    mounted: function() {
        M.updateTextFields();
    },
    created: function() {
        this.modalWidth = window.innerWidth < this.modalWidth
        ? this.modalWidth / 2
        : this.modalWidth
    },
    methods: {
        open: function() {
            this.$modal.show('PrayerRequest', 
                {
                    height: 'auto'
                }
            );
        },
        onSubmit: function() {
            var self = this;
            this.isDisabled = true;
            this.success = false;
            const payload = this.form;
            MessagesService.sendPrayerRequest(payload).then(function(response) {
                if (response.statusCode == 200) {
                    self.success = true;
                }
                else {
                    self.isDisabled = false;
                }
            });
        },
        beforeOpen: function() {
            document.querySelector("body").classList.add("modal-open");
        },
        beforeClose: function() {
            document.querySelector("body").classList.remove("modal-open");
            this.resetForm();
        },
        resetForm: function() {
            this.success = false;
            this.isDisabled = false;
            this.form = {
                FirstName: "",
                LastName: "",
                Email: "",
                Phone: "",
                Request: ""
            }
        }
    },
    computed: {
        buttonDisabled: function() {
            if (this.form.FirstName == '' && this.form.LastName == "" && this.form.Email == '' && this.form.Phone == '' && this.form.Request == '') {
                return false;
            }
            else     {
                return true;
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-trigger {
        line-height: 58px;
        font-size: 1.25rem;
        padding: 0px 50px;
        background: rgba(91,124,138, .7);
    }

    button {
        /* line-height: 58px; */
        /* font-size: 1.25rem; */
        /* padding: 0px 50px; */
        background: rgba(91,124,138, .7);
    }

    .modal-trigger:hover,
    button:hover {
        color: #fff;
        background: rgba(91,124,138, 1);
    }

    form {
        padding: 2rem 3rem;
        overflow-y: auto;
        max-height: 100vh;
        overflow-x: hidden;
    }

    form .row {
        margin-bottom: 0;
    }

    form .title {
        color: #000000;
        font-size: 1.5rem;
    }

    form input, 
    form textarea {
        /* color: #ffffff; */
        font-size: 1.25rem;
        font-family: 'NewhouseDTCond-ExtBold';
    }

    .title { 
        float: left;
    }
    
    .close {
        color: #000;
        /* position: absolute;
        right: 2rem;
        top: 2rem; */
        cursor: pointer;
        float: right;
    }
    .input-field {
        margin-bottom: 0;
    }

    .input-field span {
        color: red;
    }
    .v--modal {
        background: rgba(9,12,13, .9);
    }

    .reset-div {
        margin-top: 10px;
        cursor: pointer;
    }

    .success {
        color: #000;
        height: 35px;
        font-size: 1.5rem;
        font-family: 'NewhouseDTCond-ExtBold';
    }

    .reset-div button {
        color: #5b7c8a;
        background: transparent;
        border: none;
        cursor: pointer;
    }

    .v--modal-overlay .v--modal-box {
        overflow: auto;
    }
</style>
